var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home text-center"},[_c('img',{staticClass:"home-logo inline-block",attrs:{"src":"img/logo.png","alt":"FleetUp"}})])}]

export { render, staticRenderFns }